define 'custom/controller', ->

  # simple dom element related object store to avoid jQuery.data() dependency
  class DataStore
    data: {}
    increment: 0
    getId: (el) ->
      el.getAttribute('data-controller-id')
    setId: (el, id) ->
      el.setAttribute('data-controller-id', id)
    set: (el, name, value) ->
      id = @getId(el)
      if not id
        id = @increment++
        @setId(el, id)
      @data[id] = {} if not @data[id]?
      @data[id][name] = value
    get: (el, name) ->
      id = @getId(el)
      @data[id][name] if id? and @data[id]?
    remove: (el, name) ->
      id = @getId(el)
      delete @data[id][name] if id? and @data[id]?
    removeAll: (el) ->
      id = @getId(el)
      delete @data[id] if id?

  data = new DataStore()

  # traverses the complete dom looking for uninitialized elements with controller annotation and initializes them
  scan = ->
    # check if css for this page is already loaded
    
    #if isContentHidden()
    #  setTimeout scan, 50
    #  return
    #console.log " .... scanning "
    initialize(el) for el in document.querySelectorAll('[data-controller]')

  #isContentHidden = ->
  #  el = document.querySelector("#content > div")
  #  return false if not el?
  #  window.getComputedStyle(el).getPropertyValue("visiblity") is "hidden"

  # loads the elements controller module and instanciates it with the element
  initialize = (el) ->
    controllerList = el.getAttribute('data-controller')
    #console.log controllerList
    names = controllerList.split('|')

    for name in names
      if not (data.get(el, "loading-#{name}") or data.get(el, "instance-#{name}")?)
        # not initialized yet
        data.set(el, "loading-#{name}", true)

        # loading required controller class
        moduleName = "controller/#{name}"
        
        #console.log moduleName

        try
          require [moduleName, 'jquery'], (Controller, $) ->
            # instanziating controller and saving state
            #console.log "controller init: ", moduleName

            instance = new Controller($(el))
            data.set(el, "instance-#{name}", instance)
            data.remove(el, "loading-#{name}")
        catch e
          console.log(e)

  # unbinds existing controllers in the content area before pjax swaps the content dom.
  # we need to do this, so that garbage collection can remove the then unused controllers
  # because otherwise they would still have bindings to detached dom elemnets.
  destroy = ($container, includeContainer = true) ->
    #console.log "destroy controller: ", $container, " includeContainer: ", includeContainer
    $elements = $container.find('[data-controller]')
    if includeContainer and $container.data('controller')?
      $elements = $elements.add($container)

    $elements.each (i, el) ->
      controllerList = el.getAttribute('data-controller')
      names = controllerList.split('|')
      for name in names
        instance = data.get(el, "instance-#{name}")
        if instance?
          instance.destroy() if instance.destroy?
          # delete all references/fields to avoid memory leaks
          delete instance[field] for field, value of instance
      data.removeAll(el)

  return {
    scan: scan
    destroy: destroy
  }